const TRANSLATIONS: Record<string, string> = {
  "usageDataFrom.SERVICE_PROVIDER": "Service Provider",
  "usageDataFrom.MANUAL_SCHEDULE": "Manual Schedule",
  "usageDataFrom.SEMI_AUTOMATED_SCHEDULE": "Semi Automated Schedule",
  "usageDataFrom.TELEMETRY": "Telemetry",
  "usageDataFrom.PLC": "PLC",
  "scheduleViewType.ALL": "All",
  "scheduleViewType.MANUAL": "Manual",
  "scheduleViewType.SEMI_AUTOMATED": "Semi Automated",
  SOLAR_CHARGER: "Solar Charger",
  INVERTER: "Inverter",
  GENERATING: "Generating",
  OFFLINE: "Offline",
  FAULT: "Error",
  PER_UNIT: "Per Unit",
  TOTAL_PRICE: "Total Price",
  PENDING: "Pending",
  ACTIVE: "Active",
  EXPIRED: "Expired",
  enabled_online: "Enabled Online",
  DISCHARGE: "Discharge",
  CHARGE: "Charge",
  STANDBY: "Standby",
  Total_DeviceType_Generator: "Generator",
  Total_DeviceType_meter: "Meter",
  Total_DeviceType_BMS: "BMS",
  Total_DeviceType_Switch: "Switch",
  Total_DeviceType_Air: "Air",
  Total_DeviceType_inverter: "Inverter",
  Total_DeviceType_Fire: "Fire",
  Total_DeviceType_cabinet: "Cabinet",
  Total_FaultLevel_Prompt: "Prompt",
  Total_FaultLevel_alarm: "Alarm",
  Total_FaultLevel_Fault: "Fault",
  Total_FaultType_Protect: "Protect",
  Total_FaultType_Operation: "Operation",
  Total_FaultType_Communication: "Communication",
  Total_FaultType_System: "System",
  KE: "Kenya",
  UG: "Uganda",
  TZ: "Tanzania",
  BRAND_PRIORITY: "Brand Priority",
  SAME_BRAND_ECOSYSTEM: "Use Same Brand Ecosystem",
  MINIMIZE_COMPONENT_COUNT: "Minimize Component Count",
  MATCH_VOLTAGE_ACROSS_COMPONENTS: "Match Voltage Across Components",
  MINIMIZE_MAINTENANCE_RISK: "Minimize Maintenance Risk",
  OPTIMIZE_FOR_COST: "Optimize For Cost",
  PREFER_HIGH_EFFICIENCY_PANELS: "Prefer High-Efficiency Panels",
  RECOMMEND_EXPANDABLE_SYSTEMS: "Recommend Expandable Systems",
};

export default function translate(key: string, category?: string) {
  let fullKey = `${category}.${key}`;
  if (!category) {
    fullKey = key;
  }

  return TRANSLATIONS[fullKey] || key;
}
